import styled from "styled-components";
export const CheckName = styled("span") `
  font-weight: bold;
  margin-bottom: 5px;
  display: inline-block;
  padding-top: 0.3rem;
`;
CheckName.displayName = "CheckName";
